import Vue from 'vue'
import Events from '../events'
import router from '../router'
import ExamMixin from './ExamMixin'
import auth from './../auth'

export default {
    name: 'ExamEvaluateMixin',
    mixins: [ExamMixin],
    props: {
        evaluator: {
            type: [String],
            default: ''
        }
    },
    data() {
        return {
            evaluation: {
                criteriaScores: {},           
                notes: '',                
                finalScore: 0,
                started: false,
                finished: false,
                startDate: '',
                finishDate: ''                
            },
            criteria: [],
            criteriaStatus: {},
            criteriaScoreLoaded: false,
            notesStatus: 'sent',
            finishOk: false,
            errors: null,
            evaluatorName: '',
            loadingFinalScore: false
        }
    },
    computed: {
        orderedCriteria: function () {
            function dynamicSort(property) {
                var sortOrder = 1;
                if (property[0] === "-") {
                    sortOrder = -1;
                    property = property.substr(1);
                }
                return function (a, b) {
                    var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
                    return result * sortOrder;
                }
            }
            return this.criteria.sort(dynamicSort('pos_ext'))
        },
        canEdit: function () {
            return this.evaluator == '' || auth.user.id == this.evaluator
        },
        canViewOrEditCriteria: function () {
            return this.criteriaScoreLoaded || this.canEdit
        },
        formattedFinalScore: function () {
            let x = this.evaluation.finalScore
            return (Number.isInteger(x)) ? (x + ".0") : (x.toString())            
        }
    },
    methods: {
        startEvaluation: function(callback) {
            this.$http.post('startEvaluation', { exam: this.exam.id }).then(response => {
                this.evaluation.started = true
                this.evaluation.startDate = new Date()
            }, response => {
                if (typeof response.data.errors !== 'undefined') {
                    this.errors = response.data.errors
                }
                console.log('Erro ao iniciar avaliação da banca ' + this.exam.id)
            })
        },
        saveEvaluationData: function() {
            this.submitEvaluationData().then(responses => {            
                this.submited = responses.every(function (response) {
                    let ok = typeof response.data.status !== 'undefined' && response.data.status == 'ok'
                    if (!ok) this.handleBadResponse(response)
                    return ok
                })
            }, responses => {
                for (let key in responses) {
                    console.error('Erro ao submeter os dados para o servidor.');
                    this.handleBadResponse(responses[key])
                }
            })
        },
        submitEvaluationData: function() {
            return Promise.all([this.submitNotes(false)].concat(this.submitCriteria()))
        },
        submitNotes: function(resolve) {
            let params = {
                'exam': this.exam.id,
                'notes': this.evaluation.notes
            }
            this.notesStatus = 'sending'
            let promise = this.$http.post('setEvaluationNotes', params)
            if (resolve) {
                promise.then(response => {
                    let ok = typeof response.data.status !== 'undefined' && response.data.status == 'ok'
                    if (ok) this.notesStatus = 'sent'
                })
            } else {
                return promise
            }
        },
        submitCriteria: function() {
            let promises = []
            for (let criterionId in this.evaluation.criteriaScores) {
                promises.push(this.submitCriterion(criterionId))
            }
            return promises
        },        
        submitCriterion: function(criterion, onlyPromise=true) {
            let criterionId = criterion.id
            let criterionScore = this.evaluation.criteriaScores[criterionId]
            if (typeof criterionScore === 'undefined' || criterionScore == '') {
                criterionScore = ''
            }
            /*
            console.log(criterion);
            if (typeof criterionScore === 'undefined' || parseFloat(criterionScore) > 10) {
                this.$swal({
                    type: 'warning',
                    text: 'Atenção, não é possível registrar nota superior a 10,00',
                    showConfirmButton: false,
                    timer: 3000
                })
                this.$set(this.evaluation.criteriaScores, [criterion.id], 0);
                return false;
            }
            */
           
            let params = {
                'exam': this.exam.id,
                'criterion': criterionId,
                'score': criterionScore
            }                 
            let promise = this.$http.post('fillEvaluationCriterion', params)
            if (onlyPromise) {
                return promise
            } else {
                criterion.status = 'sending'
                this.$forceUpdate()
                promise.then(function() {
                    criterion.status = 'sent'
                    this.calcEvaluationScore()
                })
            }
        },
        calcEvaluationScore: function() {
            this.loadingFinalScore = true            
            this.$http.put('calcEvaluationScore', { exam: this.id }).then(response => {
                this.loadingFinalScore = false
                if (typeof response.data.status !== 'undefined' && response.data.status == 'ok') {
                    this.evaluation.finalScore = response.data.score
                } else {
                    alert('Não foi possível calcular a nota da avaliação.');
                }
            }, response => {
                alert('Não foi possível calcular a nota da avaliação.');
            })
        },
        finishEvaluation: function() {
            this.submitEvaluationData().then(responses => {
                this.submited = responses.every(function (response) {
                    let ok = typeof response.data.status !== 'undefined' && response.data.status == 'ok'
                    if (!ok) this.handleBadResponse(response)
                    return ok
                })                
                if (this.submited) {
                    this.submited = false
                    this.$http.put('finishEvaluation', { exam: this.exam.id }).then(response => {
                        if (typeof response.data.status !== 'undefined' && response.data.status == 'ok') {
                            this.submitErrors = false
                            this.submited = true
                            this.finishOk = true
                        } else {
                            this.handleBadResponse(response)
                        }
                    }, response => {
                        console.error('Erro ao submeter os dados para o servidor.')
                        this.handleBadResponse(response)
                    })
                }
            })
        },
        submit: function () {
            this.$swal({
                type: 'warning',
                title: 'Atenção',
                text: "Deseja realmente finalizar?",
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Sim',
                showCancelButton: true,
                cancelButtonColor: '#d33',
                cancelButtonText: 'Não'
              }).then((result) => {
                this.finishEvaluation()
              })
        },
        handleBadResponse: function (response) {
            this.submitErrors = []
            console.log(response.body.errors)
            if (typeof response.body.errors !== 'undefined') {
                for (let key in response.body.errors) this.submitErrors.push(response.body.errors[key]);
            } else {
                this.submitErrors.push('Erro não especificado no servidor.')
            }
            return this.submitErrors
        },
        init: function () {
            ExamMixin.methods.init.call(this)
            // Init evaluator name with id, until complete name is loaded from server
            this.evaluatorName = this.evaluator
            if (this.id) {
                this.$http.post('criteria', { exam: this.id }).then(response => {
                    if (response.data.status == 'ok') {
                        this.criteria = response.data.criteria
                        for (let key in this.criteria) {
                            // TODO Fazer isso no lado do servidor
                            let criterion = this.criteria[key]
                            criterion.status = 'sent'
                            this.criteria[key].pos_ext = criterion.pos.split('.').map(function(n){return n.lpad(10)}).join('.')
                            this.criteria[key].parent_pos = criterion.pos.split('.').slice(0, -1).join('.')
                        }
                    } else {
                        this.fatalError = true
                        console.error('Erro ao buscar critérios de avaliação do trabalho.')
                        console.debug(response)
                        this.errors = this.handleBadResponse(response)
                    }
                }, response => {
                    this.fatalError = true
                    console.error('Erro ao buscar informações de avaliação do trabalho.')
                    console.debug(response)
                    this.errors = this.handleBadResponse(response)
                });       
                this.$http.post('evaluations', { exam: this.id }).then(response => {
                    if (response.data.status == 'ok') {
                        let evaluations = response.data.evaluations
                        if (!evaluations || evaluations == null || evaluations.length == 0) return false;
                        let evaluator = this.evaluator != '' ? this.evaluator : auth.user.id
                        if (typeof evaluations[evaluator] === 'undefined') return false;
                        let evaluation = evaluations[evaluator]
                        if (typeof evaluation.examiner !== 'undefined' && typeof evaluation.examiner.name !== 'undefined'
                            && evaluation.examiner.name != '') {
                            this.evaluatorName = '[' + this.evaluator + '] ' + evaluation.examiner.name
                        }                        
                        if (typeof evaluation.start !== 'undefined' && evaluation.start != null) {
                            this.evaluation.started = true                                                
                            this.evaluation.startDate = evaluation.start
                            for (let criterionId in evaluation.criteria) {
                                let criterionScore = evaluation.criteria[criterionId]
                                this.evaluation.criteriaScores[criterionId] = criterionScore
                                this.criteriaScoreLoaded = true
                            }
                            if (typeof evaluation.notes === 'string') {
                                this.evaluation.notes = evaluation.notes                            
                            }
                            if (typeof evaluation.finish != 'undefined' && evaluation.finish != null) {
                                this.evaluation.finished = true
                                this.evaluation.finishDate = evaluation.finish
                                this.evaluation.finalScore = evaluation.final_score
                            } else {
                                this.calcEvaluationScore()
                            }
                        }
                    } else {
                        this.fatalError = true
                        console.error('Erro ao buscar estado anterior da avaliação.')
                        console.debug(response)
                        this.errors = this.handleBadResponse(response)
                    }
                }, response => {
                    this.fatalError = true
                    console.error('Erro ao buscar estado anterior da avaliação.')
                    console.debug(response)
                    this.errors = this.handleBadResponse(response)
                });                           
            }
        },
    },
    created: function () {

    },
    watch: {
        'evaluation.notes': function (to, from) {
            //this.submitNotes() // TODO submit evaluation in real time
        },
        'evaluation.criteriaScores': function (to, from) {
            //this.submitNotes()
        }             
    }
}


// WEBPACK FOOTER //
// ./src/components/ExamEvaluateMixin.js